import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useT } from "../lib/i18n";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="mt-20 border-t border-border bg-navy text-white">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center">
              <img src="/woningalert-logo-white.png" alt="WoningAlert" className="h-9 w-auto" />
            </Link>
            <p className="mt-4 max-w-sm text-sm text-white/60">{t("home.hero.subtitle")}</p>
            <a
              href="https://www.instagram.com/officialwoningalert"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white hover:bg-white/20"
              data-testid="footer-instagram"
              aria-label="Volg WoningAlert op Instagram"
            >
              <Instagram size={16} />
              @officialwoningalert
            </a>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-white/90">{t("nav.woningen")}</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              <li><Link to="/woningen" className="hover:text-white">{t("nav.woningen")}</Link></li>
              <li><Link to="/scam-check" className="hover:text-white">{t("nav.scamcheck")}</Link></li>
              <li><Link to="/prijzen" className="hover:text-white">{t("nav.prijzen")}</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-white/90">{t("nav.account")}</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              <li><Link to="/login" className="hover:text-white">{t("nav.login")}</Link></li>
              <li><Link to="/register" className="hover:text-white">{t("nav.register")}</Link></li>
              <li><Link to="/dashboard" className="hover:text-white">{t("nav.dashboard")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-white/90">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              <li><Link to="/over-ons" className="hover:text-white">{t("footer.about")}</Link></li>
              <li><Link to="/privacy" className="hover:text-white">{t("footer.privacy")}</Link></li>
              <li><Link to="/voorwaarden" className="hover:text-white">{t("footer.terms")}</Link></li>
              <li><Link to="/cookiebeleid" className="hover:text-white">{t("footer.cookies")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/40">
          © {new Date().getFullYear()} WoningAlert. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};
